module.exports = __webpack_public_path__ + "img/heart.ccfc9c0a.svg";